import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import { push } from 'react-router-redux';
import RaisedButton from 'material-ui/RaisedButton';
import Paper from 'material-ui/Paper';
import styles from './styles';

import { getProfile, resendEmailVerification } from '../../../utils/authenticated';

class VerifyEmail extends Component {
  static propTypes = {};

  constructor(props) {
    super(props);
    this.state = {
      message: '',
    };
  }

  handleSendVerification = () => {
    return resendEmailVerification(getProfile().sub)
      .then(() => {
        console.log('success');
        this.props.push('/login');
      }).catch((err) => {
        console.error('error', err);
      });
    // FirebaseTools.sendEmailVerification().then((res) => {
    //   this.setState({
    //     message: res.message,
    //   });
    // });

  };

  render() {
    return (
      <div style={styles.container}>
        <img alt="Logo" src="/images/logo.png"/>
        <Paper style={styles.paper} zDepth={5}>
          <h5> {this.state.message} </h5>
          <div>You must verify your email prior to gaining access to the system</div>

          <div style={styles.button}>
            <RaisedButton type="submit" label="Resend Verification" secondary
                          onClick={() => this.handleSendVerification()}/>
          </div>

          <div style={styles.button}>
            <RaisedButton type="submit" label="Login" secondary containerElement={<Link to={'/login'}/>}/>
          </div>
        </Paper>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    message: state.message,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    push,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(VerifyEmail);



// WEBPACK FOOTER //
// ./src/components/Authentication/VerifyEmail/index.js